import React, { useState } from 'react'
import { tokens } from "../../theme";
import { Grid ,useTheme,Box,Button} from '@mui/material';
import TextField from '@mui/material/TextField';
import axios from 'axios'


export const Contact = () => {
  const theme = useTheme();// eslint-disable-next-line
  const colors = tokens(theme.palette.mode);
  let [nameerrors,seterror]=useState(false)
  let [mailerrors,setmailerror]=useState(false)
  let [phoneeerrors,setphoneerror]=useState(false)
  let [msgerror,setmsgerror]=useState(false)
  const initialstate={
    name:'',
    phone:'',
    email:'',
    msg:''
  }
  const[data,setdata]=useState(initialstate)
  const changeHandler = e => {
    setdata({...data, [e.target.name]: e.target.value})
 }
 const handleclick=(data)=>{
   if (data.name === '' || data.email === '' || data.phone === '' || data.msg === '') {
     if (data.name === '') {
       seterror(true)
     }
     if (data.email === '') {
       setmailerror(true)
     }
     if (data.phone === '') {
       setphoneerror(true)
     }
     if (data.msg === '') {
       setmsgerror(true)
     }
     
   }else{
    sendmail()
   }
 }

 async function sendmail(){
  
  const response= await axios.post("https://vercel-gold-beta.vercel.app/users",data)
  if(response.data.msg==='Mail sended'){
    setempty()
    alert("Thank You....!")

  }
  else{
    console.log(response)
  }
 }
 function setempty(){
  setdata(initialstate)

 }
  
  return (
    <Grid xs={12} md={6}   marginTop={10} flexDirection={{ xs: 'column', sm: 'row', md: 'row', lg: 'row' }} justifyContent={{ xs: 'center', md: 'flex-end' }}
    alignItems={{ xs: 'center', md: 'flex-end' }} >
        <Box
        gridColumn={12}
        gridRow={6}
        
        height={500}
        
        
      >
        <Box display={'flex'}
        flexDirection='column' justifyContent={'center'} alignItems={'center'} rowGap={2}>
        <TextField
            error={nameerrors}
            id="outlined-basic"
            color="secondary"
            label="Name"
            name='name'
            variant="outlined"
            type="text"
            value={data.name}
            sx={{  width:'50%',marginTop:'10px' }}
            onChange={changeHandler}
            
          />
          <TextField
            error={mailerrors}
            id="outlined-basic"
            color="secondary"
            name='email'
            label="Email"
            variant="outlined"
            value={data.email}
            type="email"
            sx={{  width:'50%',marginTop:'10px' }}
            onChange={changeHandler}
          />
          <TextField
            error={phoneeerrors}
            id="outlined-basic"
            color="secondary"
            label="Phnoe"
            value={data.phone}
            name='phone'
            variant="outlined"
            type="text"
            sx={{  width:'50%',marginTop:'10px' }}
            onChange={changeHandler}
          />
          <TextField
           error={msgerror}
            id="outlined-basic"
            color="secondary"
            label="Massage"
            value={data.msg}
            name='msg'
            variant="outlined"
            type="text"
            sx={{  width:'50%',marginTop:'10px' }}
            onChange={changeHandler}
          />
         <Button variant="contained" color="success" onClick={handleclick} >Contact</Button>
        </Box>
      </Box>
    </Grid>
  )
}
